<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>券包设置>新建优惠券包</div>
		<div class="newADcontent">
			<div class="adContent">
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<div class="father">
					<div class="left">
						<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
							<el-form-item label="券包名称">
								<!-- <el-input v-model="addDataList.name" size="small" style="width: 400px;" maxlength="12" show-word-limit placeholder="输入名称，不超过12个字"></el-input> -->
								<el-input v-model="addDataList.name" size="small" style="width: 400px;"></el-input>

							</el-form-item>
							<!-- <el-form-item label="使用门槛">
						<p>
							<el-radio v-model="addDataList.threshold" label="1">无门槛使用</el-radio>
						</p>
						<p style="margin-top: 20px;">
							<el-radio v-model="addDataList.threshold" label="2">
								满
								<el-input type="number" v-model="addDataList.money" style="width: 150px;" size="small"></el-input>
								元使用
							</el-radio>
						</p>
					</el-form-item> -->
							<el-form-item label="券包类型">
								<el-radio v-model="addDataList.type" label="0">满减券</el-radio>
								<el-radio v-model="addDataList.type" label="1">实物兑换</el-radio>
								<el-radio v-model="addDataList.type" label="2">充值商品兑换</el-radio>
								<el-radio v-model="addDataList.type" label="3">组合</el-radio>
							</el-form-item>
							<el-form-item label="券包内容">
								<div v-for="(item,index) in selectcoupons">
									<span style="margin-right: 2px;">券{{index+1}}</span>
									<el-tag style="color: #444444;font-size: 14px;border-color: #c9cacf;">
										{{item.title + ':' + item.remark}}
									</el-tag>
								</div>
								<el-button @click="addCoupons = true,pop1 = true" type="text" style="color: #999;"><i
										class="el-icon-plus"></i>添加券</el-button>
							</el-form-item>
							<el-form-item label="券包兑换积分数">
								<span style="margin-right: 2px;">每次兑换需要</span>
								<el-input-number v-model="addDataList.integral" size="small" :min="0"
									style="width: 150px;" :precision="2"></el-input-number>
								<span style="margin-right: 2px;">积分</span>
							</el-form-item>
							<el-form-item label="劵包价格">
								<el-input-number v-model="addDataList.price" size="small" :min="0" style="width: 150px;"
									:precision="2"></el-input-number>
							</el-form-item>
							<el-form-item label="券包可用优惠券">
								<div v-for="(item,index) in selectavailableCoupon">
									<span style="margin-right: 2px;">券{{index+1}}</span>
									<el-tag style="color: #444444;font-size: 14px;border-color: #c9cacf;">
										{{item.title + ':' + item.remark}}
									</el-tag>
								</div>
								<el-button @click="addCoupons = true,pop2 = true" type="text" style="color: #999;"><i
										class="el-icon-plus"></i>添加券</el-button>
							</el-form-item>
							<!-- <el-form-item label="发行量">
						<el-input type="number"  v-model="addDataList.circulation" size="small" style="width: 200px;" placeholder="最多500000张"></el-input>
						<p style="font-size: 12px;color: #999;">优惠券创建后，发行量只能增加不能减少，请谨慎设置</p>
					</el-form-item> -->
							<el-form-item label="使用时间">
								<p>
									<!-- <el-radio v-model="addDataList.timeList" label="1"> -->
									<el-date-picker size="small" v-model="addDataList.time" type="datetimerange"
										value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期">
									</el-date-picker>
									<!-- </el-radio> -->
								</p>
								<!-- <p style="margin-top: 20px;">
							<el-radio v-model="addDataList.timeList" label="2">
								领去当日起
								<el-input v-model="addDataList.dayCount" size="small" style="width: 200px;"placeholder="填写天数"></el-input>
								天内可用
							</el-radio>
						</p> -->
							</el-form-item>
							<!-- 接口	直接上架到积分商城 供客户使用积分兑换	 -->
							<el-form-item label="是否显示在积分商城">
								<!-- <el-radio-group> -->
								<el-radio v-model="addDataList.displayMall" label="1">显示</el-radio>
								<el-radio v-model="addDataList.displayMall" label="0">不显示</el-radio>
								<!-- </el-radio-group> -->
							</el-form-item>
							<el-form-item label="领取次数限制">
								<p>
									<el-radio v-model="addDataList.count" label="100">不限次数，每人最多领取100张</el-radio>
								</p>
								<p style="margin-top: 20px;">
									<el-radio v-model="addDataList.count" label="1">
										每人限领取
										<el-select style="width: 100px;margin:0 20px;" size="small"
											v-model="addDataList.timeLimitCount">
											<el-option v-for="item in countList" :key="item.value" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										次
									</el-radio>
								</p>
							</el-form-item>
							<el-form-item label="券包标签">
								<!-- <el-radio-group> -->
								<el-radio v-model="addDataList.label" label="0">新品</el-radio>
								<el-radio v-model="addDataList.label" label="1">热销</el-radio>
								<el-radio v-model="addDataList.label" label="2">经典</el-radio>
								<!-- </el-radio-group> -->
							</el-form-item>
							<el-form-item label="使用规则/文字描述" style="height: 350px;">
								<quill-editor v-model="addDataList.text" ref="myQuillEditor"
									style="height: 200px; width: 500px;">
								</quill-editor>
							</el-form-item>
							<el-form-item label="备注" style="height: 100px;">
								<el-input type="textarea" v-model="addDataList.msg" style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button @click="goback">取消</el-button>
								<el-button type="primary" @click="addvolum(1)" style="margin-left: 20px;">保存</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="right">
						<el-form>
							<el-form-item label="上传图片">
								<div style="display: flex;">
									<div>
										<p style="font-size: 14px;color: #808080;margin-left: 20px;">上传封面图</p>
										<upload v-model="addDataList.smallImg"  class="el-tabs-pane-upload"  ref="sss"
											style="width: 100px; height: 100px;margin-top: 10px; " />

									</div>
									<div>
										<p style="font-size: 14px;color: #808080;margin: 0px 0 0 20px;">上传图片（非必填）</p>
										<upload v-model="addDataList.bigImg"  class="el-tabs-pane-upload"  ref="sss"
											style="width: 300px; height: 1080px; margin: 10px 0 0 30px;" />

									</div>
								</div>
							</el-form-item>
						</el-form>
					</div>
					<!-- <el-form-item label="活动叠加限制">
						<el-checkbox v-model="addDataList.activeLimit">优惠券仅原价购买商品时可用，不可与其他营销活动叠加使用</el-checkbox>
					</el-form-item> -->
				</div>
			</div>
		</div>
		<!-- 添加券 -->
		<el-dialog title="添加券" :visible.sync="addCoupons" width="70%">
			<el-input v-model="filter.name" size="small" style="width: 200px;" placeholder="输入优惠券名称"></el-input>
			<el-button type="primary" @click="getjuan" style="margin-left: 20px;" size="small">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-if="pop1" v-model="addDataList.coupons">
					<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id+''"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券名称" prop="title" align="center">
						</el-table-column>
						<el-table-column prop="content" align="center" label="券内容">
							<template slot-scope="scope">
								<div style="height:80px; text-overflow:ellipsis;">
									<p v-html='scope.row.content'></p>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								{{scope.row.termOfValidity}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.getNumScaleTotalNum}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="useNum" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-checkbox-group v-if="pop2" v-model="addDataList.availableCoupon">
					<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id+''"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券名称" prop="title" align="center">
						</el-table-column>
						<el-table-column prop="content" align="center" label="券内容">
							<template slot-scope="scope">
								<div style="height:80px; text-overflow:ellipsis;">
									<p v-html='scope.row.content'></p>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								{{scope.row.termOfValidity}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.getNumScaleTotalNum}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="useNum" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, prev, pager, next"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="filter.page"
					:total="filter.total">
				</el-pagination>
			</div>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="addCoupons=false,pop1 = false,pop2=false">取消</el-button>
					<el-button size="small" type="primary" @click="handleClick()">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";

	const allCoupons = []
	export default {
		components: {
			upload
		},
		inject: ['reload'],
		data() {
			return {
				id: "",
				filter: {
					page: 1,
					size: 10,
					name: undefined,
					total: 0
				},
				addDataList: {
					id: undefined,
					name: undefined,
					type: undefined,
					threshold: undefined,
					money: undefined,
					displayMall: 0,
					integral: undefined,
					circulation: undefined,
					time: undefined,
					timeList: undefined,
					dayCount: undefined,
					count: undefined,
					text: undefined,
					msg: undefined,
					smallImg: undefined,
					bigImg: undefined,
					activeLimit: false,
					availableCoupon: [],
					coupons: [],
					price: 0,
					time: [],
					label: 2,
					endTime: "",
					startTime: ''
				},
				countList: [{
					value: "1",
					label: "1"
				}, {
					value: "2",
					label: "2"
				}, {
					value: "3",
					label: "3"
				}],
				addCoupons: false,
				pop1: false,
				pop2: false,
				dataList: [],
				dataCheck: [],
				selectcoupons: [],
				selectavailableCoupon: [],
				allCoupons: []
			}
		},
		mounted() {
			this.getjuan()
			
			this.addDataList.id = this.$route.query.id
			// 券包
			if (this.addDataList.id) {
				this.$http.get("couponPackage/getById?id=" + this.addDataList.id).then(function(res) {
					this.addDataList = JSON.parse(JSON.stringify(res.body.data));
					this.addDataList.price = this.addDataList.price / 100
					this.addDataList.time = new Array();
					this.addDataList.time[0] = this.addDataList.startTime
					this.addDataList.time[1] = this.addDataList.endTime
					if (this.addDataList.coupons != null)
						this.addDataList.coupons = this.addDataList.coupons.split(",");
					if (this.addDataList.availableCoupon != null)
						this.addDataList.availableCoupon = this.addDataList.availableCoupon.split(",");
					if (this.addDataList.type == 0) {
						this.addDataList.type = "0"
					} else {
						this.addDataList.type = this.addDataList.type.toString()
					}
					if (this.addDataList.displayMall == 0) {
						this.addDataList.displayMall = "0"
					} else {
						this.addDataList.displayMall = this.addDataList.displayMall.toString()
					}
					if (this.addDataList.count) {
						this.addDataList.count = this.addDataList.count.toString()
					}
					if (this.addDataList.label == 0) {
						this.addDataList.label = "0"
					} else {
						this.addDataList.label = this.addDataList.label.toString()
					}
					this.setTimeOut(500,this.updatevolum())
					
				})
			}
		},
		methods: {
			updatevolum() {
				this.selectcoupons = [],
					this.selectavailableCoupon = [],
					this.$http.get("dCoupon/list?pageNum=1&pageSize=99999").then(function(res) {
						this.allCoupons = res.body.data
						this.allCoupons.forEach(all => {
							if (this.addDataList.coupons != null) {
								this.addDataList.coupons.forEach(couponsId => {
									if (couponsId == all.id) {
										this.selectcoupons.push(all)
									}
								})
							}
							if (this.addDataList.availableCoupon != null) {
								this.addDataList.availableCoupon.forEach(availableCouponId => {
									if (availableCouponId == all.id) {
										this.selectavailableCoupon.push(all)
									}
								})
							}
						})
					})
			},
			getjuan() {
				var s = "pageNum=" + this.filter.page + "&pageSize=" + this.filter.size;
				this.$http.get("dCoupon/list?" + s).then(function(res) {
					if (res.body.code == 200) {
						this.dataList = res.body.data
						this.filter.total = res.body.total
					}
				})
			},
			goback() {
				this.$router.go(-1)
			},
			// 添加卷包
			addvolum(r) {
				let arr = {}
				if (this.addDataList.name == "") {
					return this.$message.error("卷包的名称不能为空")
				}
				arr.name = this.addDataList.name
				if (this.addDataList.coupons.length == 0) {
					return this.$message.error("卷包里面的优惠券不能为空")
				} else {
					arr.coupons = this.addDataList.coupons.toString();
				}
				if (this.addDataList.smallImg) {
					arr.smallImg = this.addDataList.smallImg;
				}
				if (this.addDataList.bigImg) {
					arr.bigImg = this.addDataList.bigImg;
				}
				if (this.addDataList.availableCoupon) {
					arr.availableCoupon = this.addDataList.availableCoupon.toString();
				}
				arr.num = this.addDataList.circulation
				if (this.addDataList.time) {
					arr.startTime = this.addDataList.time[0];
					arr.endTime = this.addDataList.time[1];
				} else {
					return this.$message.error("开始时间和结束时间不能为空")
				}
				if (this.addDataList.count != "100" && r != 0) {
					if (this.addDataList.timeLimitCount) {
						arr.count = this.addDataList.timeLimitCount
					} else {
						return this.$message.error("请选择领取次数")
					}
				} else {
					arr.count = this.addDataList.count;
				}
				arr.type = this.addDataList.type;
				arr.integral = this.addDataList.integral;
				arr.text = this.addDataList.text;
				arr.msg = this.addDataList.msg;
				arr.label = this.addDataList.label;
				arr.displayMall = this.addDataList.displayMall;
				arr.price = this.addDataList.price * 100;
				arr.id = this.addDataList.id;
				this.$http.post("couponPackage/saveDCouponPackage", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						if (r === 1) {
							this.$router.go(-1)
						}
					}
				})
			},
			handleClick() {
				this.updatevolum();
				console.log(this.$route.query.id)
				if (this.$route.query.id != null) {
					this.addvolum(0)
					this.reload();
					this.updatevolum();
					this.pop1 = false
					this.pop2 = false
				} else {
					this.addCoupons = false
					this.pop1 = false
					this.pop2 = false
				}
			},
			handleCurrentChange(val) {
				this.filter.page = val
				this.getjuan()
			},
			handleSizeChange(val) {
				this.filter.size = val
				this.getjuan()
			}
		}
	}
</script>

<style lang="less" scoped>
	.father {
		display: flex;
	}

	.left {
		/* background-color: #0000CC; */
		width: 50%;
	}

	.right {
		/* background-color: #008200; */
		width: 50%;
		height: auto;
		float: right;
	}

	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}

	/deep/ .tabelContent .el-checkbox__label {
		display: none;
	}

	.add_botom {
		width: 100%;
		height: 50px;
	}

	.add_botom_nei {
		display: inline-block;
		float: right;
	}
</style>